import { RegionUserList } from './RegionUserList'
import { AddUserToRegion } from './AddUserToRegion'

interface RegionCardProps {
  code: string
  labelPl: string
}

export function RegionCard({ code, labelPl }: RegionCardProps) {
  return (
    <section className="rounded-lg border bg-white p-4">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h2 className="text-sm font-semibold">
          {labelPl} <span className="font-mono text-xs text-slate-400">{code}</span>
        </h2>
        <AddUserToRegion regionCode={code} />
      </div>
      <RegionUserList code={code} />
    </section>
  )
}
